module.exports = __webpack_public_path__ + "static/ThirdImage-3e8c257488afb6b1dbb43df7824e9452.jpg";